import {h, Fragment} from "preact"
import { useState } from "preact/hooks";

export default function SelectPagination({ value, onClick, className, options, label }) {

    const [selectedValue, setSelectedValue] = useState(value);

    const handleClick = (e) => {
        const newValue = e.target.value;
        console.log(newValue);
        setSelectedValue(newValue);
        onClick(e);
    };

    // console.log(options);

    return (
        <div className="ns-relative ns-col-l-3 ns-pagination-select ns-d-flex ns-align-items-center ns-justify-content-center ns-justify-content-l-end">
            <div>Items per page:</div>
            <ul
            // ns-selection-dropdown-menu 
                className={`ns-text-align-left ${className} ns-d-flex ns-list-unstyled ns-m-0 ns-ml-1`}
                // value={value}
                aria-label={label || "Select"}
            >
                {options.map((option, index) => (
                    <Fragment key={option.value}>
                        <li value={option.value} onClick={handleClick} class={`ns-ml-1 ns-mr-1 ${selectedValue === option.value ? "ns-selected" : ""}`}>
                            {option.value}
                        </li>
                        {index !== options?.length - 1 && "|"}
                    </Fragment>
                ))}
            </ul>
        </div>
    )
}